/**
 * The bulk actions the Campaigns table offers.
 *
 * `BulkActions` renders a menu item only when its key appears here
 * (`BulkActions.tsx`, `mutableFields.includes(item.key)`). A key that exists in
 * `bulkActions` but not here is unreachable, so this list — not the engine gate —
 * is what makes an action available to users.
 *
 * Its own module so a test can assert against the real list rather than a copy.
 */
export const campaignMutableFields: string[] = [
    'targetAcos',
    'dailyBudget',
    'state',
    'startDate',
    'endDate',
    'portfolio',
    'smart_bid',
    // MER-2785.
    'bidStrategy',
    'tosPlacement',
    'rosPlacement',
    'ppPlacement',
]
